import React from 'react';
import type { DefaultInputComponentProps } from 'react-phone-number-input';
import Input from 'react-phone-number-input/input';

import { TextInput } from '../TextInput/TextInput';

interface PhoneInputProps extends DefaultInputComponentProps {
  value: string;
  onChange: (value: string) => void;
  error?: string;
  dataTestId?: string;
  disabled?: boolean;
  id?: string;
}

type PropsWithoutRef = Omit<PhoneInputProps, 'ref'>;

export const PhoneInput = React.forwardRef(function _PhoneInput(
  {
    value,
    onChange,
    error,
    dataTestId,
    disabled,
    id,
    ...props
  }: PropsWithoutRef,
  ref: React.Ref<HTMLInputElement>
) {
  return (
    <Input
      {...props}
      ref={ref}
      country="US"
      value={value}
      onChange={(value) => {
        // Make sure we're passing a string
        // Not doing this can cause inputs to reset in forms if the
        // user deletes the last character
        onChange(value ? value : '');
      }}
      disabled={disabled}
      id={id}
      inputComponent={TextInput}
      className={`block w-full rounded-md shadow-sm disabled:cursor-not-allowed disabled:text-gray-400 sm:text-sm ${
        error
          ? 'border-red-300 focus:border-red-300 focus:ring-red-500'
          : 'focus:border-indigo-500 focus:ring-indigo-500 border-gray-300'
      }`}
      data-testid={dataTestId}
    />
  );
});
